import Vue from 'vue';
import Vuetify, {
  VCard,
  VSheet,
  VTextField,
  VCardText,
  VTreeview,
  VToolbar,
  VToolbarTitle,
  VToolbarItems,
  VSpacer,
  VTabs,
  VTabsSlider,
  VTabItem,
  VBtn,
  VIcon,
  VBottomSheet,
  VDivider,
} from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
  components: {
    VCard,
    VSheet,
    VTextField,
    VCardText,
    VTreeview,
    VToolbar,
    VToolbarTitle,
    VToolbarItems,
    VSpacer,
    VTabs,
    VTabsSlider,
    VTabItem,
    VBtn,
    VIcon,
    VBottomSheet,
    VDivider,
  },
  icons: {
    iconfont: 'mdi',
  },
});
